var _path, _path2, _path3;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgGermanyFlag = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 32,
    viewBox: "0 0 49 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.7619 10.6667H0V0.842143C0 0.377094 0.376476 0 0.840762 0H47.9212C48.3855 0 48.762 0.377094 48.762 0.842143L48.7619 10.6667Z",
    fill: "#464655"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9211 32H0.840762C0.376476 32 0 31.6229 0 31.1578V21.3333H48.7619V31.1578C48.7619 31.623 48.3854 32 47.9211 32Z",
    fill: "#FFE15A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7619 10.6665H0V21.3326H48.7619V10.6665Z",
    fill: "#FF4B55"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgGermanyFlag, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/germany-flag.37735d10.svg";
export { ForwardRef as ReactComponent };